const routes = [
    {
        name: 'geraisEmissor',
        path: '/emissor/configuracoes/gerais',
        component: () => import('../views/Gerais'),
    },
    {
        name: 'dadosEmpresaEmissor',
        path: '/emissor/configuracoes/dados_empresa',
        component: () => import('@/domains/shared/configuracoes/lojas/views/DadosEmpresa'),
    },
    {
        name: 'marcaEmpresaEmissor',
        path: '/emissor/configuracoes/marca_empresa',
        component: () => import('@/domains/shared/configuracoes/marca_empresa/views/Editar'),
    },
    {
        name: 'certificadoDigitalEmissor',
        path: '/emissor/configuracoes/certificado_digital',
        component: () => import('@/domains/shared/configuracoes/certificado_digital/views/Index'),
    },
]

export default routes